// extracted by mini-css-extract-plugin
module.exports = {"listItemContainer":"DocumentList_listItemContainer_2UsWW","spinAround":"DocumentList_spinAround_248yL"};